import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-plano-contas-empresa-editar',
  templateUrl: './plano-contas-empresa-editar.component.html',
  styleUrls: ['./plano-contas-empresa-editar.component.scss']
})
export class PlanoContasEmpresaEditarComponent implements OnInit {

  permissaoEditar: boolean = false;
  loading: boolean = true;
  id?: number;
  planoContaEmpresa?: PlanoContaEmpresa;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  empresaSelecionada?: Empresa;
  utilizacoes: string[] = ['FOLHA DE PAGAMENTO', 'DESPESA', 'FOLHA/DESPESA', 'NÃO APLICADO' ];
  referenciasFolha: string[] = ['CREDITO', 'DESCONTO', 'NÃO APLICADO' ];
  progressoRequisicao: boolean = false;

  constructor(private planoContaEmpresaService: PlanoContaEmpresaService,
    private erroService: ErroService,
    private activatedRoute: ActivatedRoute,) { }

  ngOnInit(): void {
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_PLANO_CONTAS_EMPRESA');
    this.buscarId();
    if (this.permissaoEditar) {
      this.carregarPlanoContaEmpresa();
    }
  }

  atualizar(){
    this.progressoRequisicao = true;
    this.planoContaEmpresaService.atualizar(this.planoContaEmpresa, this.id).subscribe({
      next: (data: PlanoContaEmpresa) => {
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
        
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
      }
    })
    
  }

  carregarPlanoContaEmpresa(){
    this.planoContaEmpresaService.buscarPorId(this.id).subscribe({
      next: (data: PlanoContaEmpresa) => {
        this.planoContaEmpresa = data;
        this.loading = false;
      },
      error: (err : any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
  }

  buscarId(){
    const idParam = this.activatedRoute.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
  }

  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

}
